const getBoxesFromData = (arr, dataObj) => {
    const newArr = [];

    arr.forEach(function(listItem) {
        if (listItem.includes('img')) {
            const index = parseInt(listItem.split('box_').pop().split('_img').shift(), 10) - 1;

            if (newArr[index]) {
                if (newArr[index].img) {
                    newArr[index].img.push(dataObj[listItem]);
                } else {
                    newArr[index].img = [dataObj[listItem]];
                }
            } else {
                newArr.push({img: [dataObj[listItem]]});
            }
        }

        if (listItem.includes('text')) {
            const index = parseInt(listItem.split('box_').pop().split('_text').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].text = dataObj[listItem];
            } else {
                newArr.push({text: dataObj[listItem]});
            }
        }

        if (listItem.includes('desc')) {
            const index = parseInt(listItem.split('box_').pop().split('_desc').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].desc = dataObj[listItem];
            } else {
                newArr.push({desc: dataObj[listItem]});
            }
        }

        if (listItem.includes('title')) {
            const index = parseInt(listItem.split('box_').pop().split('_title').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].title = dataObj[listItem];
            } else {
                newArr.push({title: dataObj[listItem]});
            }
        }

        if (listItem.includes('type')) {
            const index = parseInt(listItem.split('box_').pop().split('_type').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].itemType = dataObj[listItem];
            } else {
                newArr.push({itemType: dataObj[listItem]});
            }
        }
    });

    return newArr;
};

const getItemsFromData = (arr, dataObj) => {
    const newArr = [];

    arr.forEach(function(listItem) {
        if (listItem.includes('img')) {
            const index = parseInt(listItem.split('item_').pop().split('_img').shift(), 10) - 1;

            if (newArr[index]) {
                if (newArr[index].img) {
                    newArr[index].img.push(dataObj[listItem]);
                } else {
                    newArr[index].img = [dataObj[listItem]];
                }
            } else {
                newArr.push({img: [dataObj[listItem]]});
            }
        }

        if (listItem.includes('desc')) {
            const index = parseInt(listItem.split('item_').pop().split('_desc').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].desc = dataObj[listItem];
            } else {
                newArr.push({desc: dataObj[listItem]});
            }
        }

        if (listItem.includes('title')) {
            const index = parseInt(listItem.split('item_').pop().split('_title').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].title = dataObj[listItem];
            } else {
                newArr.push({title: dataObj[listItem]});
            }
        }

        if (listItem.includes('collection_id')) {
            const index = parseInt(listItem.split('item_').pop().split('_collection_id').shift(), 10) - 1;

            if (newArr[index]) {
                newArr[index].id = dataObj[listItem];
            } else {
                newArr.push({id: dataObj[listItem]});
            }
        }
    });

    return newArr;
};

export function getBoxes(dataObj) {
    const keys = Object.keys(dataObj);
    const boxes = keys.filter(key => key.includes('box'));

    return getBoxesFromData(boxes, dataObj);
};

export function getItems(dataObj) {
    const keys = Object.keys(dataObj);
    const boxes = keys.filter(key => key.includes('item'));

    return getItemsFromData(boxes, dataObj);
};



// WEBPACK FOOTER //
// ./src/scripts/wpObjectScripts.js